import SummaryLayoutItemComponent from './SummaryLayoutItem'

export type { SummaryLayoutItem, SummaryLayoutItemProps } from './SummaryLayoutItem'

export default SummaryLayoutItemComponent
